import { Link } from "react-router-dom";
import { Loader2, Info } from "lucide-react";
import { Header, Footer } from "@/components/Layout";
import { Button } from "@/components/ui/button";

const Shell = ({ children }) => (
  <div className="min-h-screen flex flex-col bg-sand">
    <Header />
    <main className="flex-1 grid place-items-center px-6">{children}</main>
    <Footer />
  </div>
);

export const LoadingScreen = () => (
  <div className="min-h-screen grid place-items-center bg-sand">
    <Loader2 className="h-8 w-8 animate-spin text-clay" />
  </div>
);

export const NotFoundScreen = () => (
  <Shell>
    <div className="text-center max-w-md" data-testid="not-found-state">
      <h1 className="font-heading text-2xl text-ink">Result not available</h1>
      <p className="mt-3 text-ink-soft leading-relaxed">
        This result has expired or wasn't found. Since we don't store your
        statement, please run a new analysis.
      </p>
      <Button asChild className="mt-6 bg-clay hover:bg-clay-hover text-white rounded-lg px-7 py-5 font-medium">
        <Link to="/analyse">Analyse a statement</Link>
      </Button>
    </div>
  </Shell>
);

export const ProcessingScreen = () => (
  <Shell>
    <div className="text-center max-w-md" data-testid="analysing-state">
      <Loader2 className="h-10 w-10 animate-spin text-clay mx-auto" />
      <h1 className="mt-6 font-heading text-2xl text-ink">Reading your statement…</h1>
      <p className="mt-3 text-ink-soft leading-relaxed">
        Our assessor is marking all three questions against the rubric.
        This usually takes around 30 seconds — please keep this page open.
      </p>
    </div>
  </Shell>
);

export const DeclinedScreen = ({ message }) => (
  <Shell>
    <div className="text-center max-w-md" data-testid="declined-state">
      <div className="grid h-12 w-12 place-items-center rounded-xl bg-amberwarn/10 text-amberwarn mx-auto">
        <Info className="h-6 w-6" strokeWidth={2} />
      </div>
      <h1 className="mt-5 font-heading text-2xl text-ink">We couldn't give feedback</h1>
      <p className="mt-3 text-ink-soft leading-relaxed" data-testid="declined-message">
        {message ||
          "We couldn't give feedback on this submission. Please submit a genuine draft of your statement and try again."}
      </p>
      <Button asChild data-testid="declined-back-button" className="mt-6 bg-clay hover:bg-clay-hover text-white rounded-lg px-7 py-5 font-medium">
        <Link to="/analyse">Back and try again</Link>
      </Button>
    </div>
  </Shell>
);

export const FailedScreen = () => (
  <Shell>
    <div className="text-center max-w-md" data-testid="failed-state">
      <h1 className="font-heading text-2xl text-ink">Something went wrong</h1>
      <p className="mt-3 text-ink-soft leading-relaxed">
        We couldn't produce feedback this time. Please try again.
      </p>
      <Button asChild data-testid="retry-button" className="mt-6 bg-clay hover:bg-clay-hover text-white rounded-lg px-7 py-5 font-medium">
        <Link to="/analyse">Try again</Link>
      </Button>
    </div>
  </Shell>
);
